// recoil
import { atom } from 'recoil';

const localStorageEffect =
    (key, defaultObject) =>
    ({ setSelf, onSet, trigger }) => {
        const loadLocalStorage = () => {
            const value = localStorage.getItem(key);
            if (value != null) {
                setSelf(JSON.parse(value));
            }
        };

        if (trigger === 'get') {
            loadLocalStorage();
        }

        onSet((newValue, oldValue, isReset) => {
            if (isReset) {
                localStorage.removeItem(key);
            } else {
                localStorage.setItem(key, JSON.stringify(newValue));
            }
        });
    };

const LocalStorageDefault = {
    config: {
        data: null,
        meta: {
            hash: '',
            updatedAt: 0,
        },
    },
    filter: {
        recommend: [],
        search: [],
        trending: [],
        explore: [],
    },
    recommend: {
        adDistance: 0, // px of forward Recommend-feed scroll consumed since last in-feed ad
    },
    likes: {
        userId: null, // owner of the list; another user logging in starts empty
        synced: false, // true once the server's list was loaded on this device
        items: {}, // { [postId]: expireAt } of posts this user liked (see api/internal/liked-posts.js)
    },
};

const LocalStorageState = atom({
    key: 'LocalStorageState',
    default: LocalStorageDefault,
    effects: [localStorageEffect(process.env.LOCAL_STORAGE_NAME)],
});

export { LocalStorageState };
